import type { TaskQualityType } from './types';

export const TASK_QUALITY_NORMAL = 'normal';
export const TASK_QUALITY_STAGED_UNACCEPTABLE = 'staged_unacceptable';
export const TASK_QUALITY_STAGED_ACCEPTABLE = 'staged_acceptable';
export const TASK_QUALITY_STAGED_RESET = 'staged_reset';
export const TASK_QUALITY_STAGED_PASSIVE = 'staged_passive';

export function isTaskQualityType(value: unknown): value is TaskQualityType {
  return (
    value === TASK_QUALITY_NORMAL ||
    value === TASK_QUALITY_STAGED_UNACCEPTABLE ||
    value === TASK_QUALITY_STAGED_ACCEPTABLE ||
    value === TASK_QUALITY_STAGED_RESET ||
    value === TASK_QUALITY_STAGED_PASSIVE
  );
}

export function normalizeTaskQualityType(
  value: unknown,
  legacyFakeTask?: boolean | null
): TaskQualityType {
  if (isTaskQualityType(value)) return value;
  if (legacyFakeTask === true) return TASK_QUALITY_STAGED_ACCEPTABLE;
  return TASK_QUALITY_NORMAL;
}

export function isStagedUnacceptable(value: unknown): boolean {
  return normalizeTaskQualityType(value) === TASK_QUALITY_STAGED_UNACCEPTABLE;
}

export function isStagedAcceptable(value: unknown): boolean {
  return normalizeTaskQualityType(value) === TASK_QUALITY_STAGED_ACCEPTABLE;
}

export function isNormalTaskQuality(value: unknown): boolean {
  return normalizeTaskQualityType(value) === TASK_QUALITY_NORMAL;
}
